<!-- <div class="main-wrapper">
  <div class="page-wrapper full-page">
    <div class="page-content d-flex align-items-center justify-content-center">
      <div class="row w-100 mx-0 auth-page">
        <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center">
          <h4 class="mb-2">CONFIGURATION</h4>
          <form [formGroup]="configuation">
            <div class="form-group">
              <label for="power">Environment</label>
              <select class="form-control" required [(ngModel)]="envConfig"
                formControlName="envConfig">
                <option *ngFor="let en of env" [value]="en">{{en}}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tpn">TPN</label>
              <input type="text" class="form-control" required [(ngModel)]="tpn" formControlName="tpn">
              <div *ngIf="!configuation.get('tpn').valid && isSubmit" class="alert alert-danger">
                TPN is not valid
              </div>
            </div>
            <div class="form-group">
              <label>Auth Token</label>
              <textarea type="text" class="form-control" required [(ngModel)]="token" formControlName="token"></textarea>
            </div>
          </form>
          <button (click)="onFormSubmit()" class="btn btn-success" [disabled]="envConfig == '' || token == '' || tpn == ''">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div> -->
<ng-template #addConfig class="text-center m-4" let-modal>
  <p-toast position="top-right"></p-toast>
  <div class="modal-header d-flex justify-content-between">
    <h5>{{'hostedConfig.configHeader'| translate}}</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="configuation">
      <div class="card-body">
        <!-- <ng-select [(ngModel)]="envConfig"  [items]="env" [hideSelected]="true" (change)="autoConfig($event);"
          [closeOnSelect]="true" placeholder="Select Environment" formControlName="envConfig">
        </ng-select> -->
        <div class="row">
          <div class="col-6 col-md-6">
            <div class="form__div mt-md-4">
              <input type="text" name="tpn" placeholder=""
                class="form__input" [ngClass]="{'invalid-form-control': ((configuation.get('tpn').errors?.required) && 
                (configuation.get('tpn').dirty || configuation.get('tpn').touched)
                || (configuation.get('tpn').errors?.pattern))}" formControlName="tpn" [(ngModel)]="tpn" autocomplete="off"
                maxlength="12">
              <label class="form__label" for="">
                <h6>{{'hostedConfig.tpn'| translate}}</h6>
              </label>
            </div>
            <div class="row m-0 error-message"
              *ngIf="(configuation.get('tpn').dirty || configuation.get('tpn').touched)">
              <!-- <ngb-alert [dismissible]="false" [type]="'danger'" class="col-6 col-md-6 col-lg-6 pt-md-5"
                [ngClass]="{'invisible':!configuation.get('token').errors?.pattern}">
                <i class="link-icon feather icon-alert-triangle"></i>
                {{'htmlText.allowedSplChar'| translate}} _$'.,-@&
              </ngb-alert> -->
              <!-- <ngb-alert [dismissible]="false" [type]="'info'" class="text-right col-6 col-md-6 col-lg-6 pt-md-5">
                <i class="link-icon feather icon-info"></i>
                {{'htmlText.allowedSplChar'| translate}} <b>{{500 - textAreaLength}}</b>
              </ngb-alert> -->
            </div>
          </div>
          <div class="col-6 col-md-6">
            <div class="form__div mt-md-4">
              <textarea type="text" name="note" placeholder=""
                class="form__input text_area_customization" [ngClass]="{'invalid-form-control': ((configuation.get('token').errors?.required) && 
                (configuation.get('token').dirty || configuation.get('token').touched)
                || (configuation.get('token').errors?.pattern))}" formControlName="token" [(ngModel)]="token" autocomplete="off"
                maxlength="500"></textarea>
              <label class="form__label" for="">
                <h6>{{'hostedConfig.token'| translate}}</h6>
              </label>
            </div>
            <div class="row m-0 error-message"
              *ngIf="(configuation.get('token').dirty || configuation.get('token').touched)">
              <!-- <ngb-alert [dismissible]="false" [type]="'danger'" class="col-6 col-md-6 col-lg-6 pt-md-5"
                [ngClass]="{'invisible':!configuation.get('token').errors?.pattern}">
                <i class="link-icon feather icon-alert-triangle"></i>
                {{'htmlText.allowedSplChar'| translate}} _$'.,-@&
              </ngb-alert> -->
              <!-- <ngb-alert [dismissible]="false" [type]="'info'" class="text-right col-6 col-md-6 col-lg-6 pt-md-5">
                <i class="link-icon feather icon-info"></i>
                {{'htmlText.allowedSplChar'| translate}} <b>{{500 - textAreaLength}}</b>
              </ngb-alert> -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer d-flex justify-content-end">
    <button (click)="reset()" class="mt-2 text-right btn btn-danger mr-2" [disabled]="isSubmit">{{'htmlText.clear'| translate}}</button>
    <button class="mt-2 text-right btn btn-primary" [disabled]="envConfig == '' || token == '' || tpn == '' || !configuation.get('tpn').valid || isSubmit"
      (click)="onFormSubmit()">{{'htmlText.save'| translate}}</button>
  </div>

</ng-template>